import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import pcRes from '@/views/pcRes'
import mbRes from '@/views/mobileRes'

Vue.use(Router)

export default new Router({
  mode: 'history', // 去掉url中的#
  base: '/',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/pcRes',
      name: 'pcRes',
      component: pcRes
    },
    {
      path: '/mbRes',
      name: 'mbRes',
      component: mbRes
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js